// Hash-based color palette so the same brand name always renders the same
// avatar color, no DB field needed. Picks from a small slate-friendly set.
const PALETTE = [
  "bg-blue-500",
  "bg-emerald-500",
  "bg-amber-500",
  "bg-violet-500",
  "bg-rose-500",
  "bg-teal-500",
  "bg-orange-500",
  "bg-indigo-500",
];

function hashIndex(name: string): number {
  let h = 0;
  for (let i = 0; i < name.length; i++) {
    h = (h * 31 + name.charCodeAt(i)) >>> 0;
  }
  return h % PALETTE.length;
}

function initials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "·";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[1][0]).toUpperCase();
}

export function BrandAvatar({
  name,
  size = "sm",
}: {
  name: string;
  size?: "xs" | "sm" | "md";
}) {
  const cls = PALETTE[hashIndex(name)];
  const dim =
    size === "xs"
      ? "h-4 w-4 text-[9px]"
      : size === "md"
        ? "h-7 w-7 text-xs"
        : "h-5 w-5 text-[10px]";
  return (
    <span
      aria-hidden
      className={`inline-flex shrink-0 items-center justify-center rounded font-semibold text-white ${dim} ${cls}`}
    >
      {initials(name)}
    </span>
  );
}
